import './App.css';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getDistance } from './mapsAPI';
import { getGPTResponse } from './gptAPI';
import { createPlaylist, addTracksToPlaylist, getSpotifyUserId} from './spotify';
import { useNavigate } from 'react-router-dom';

function App() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [savedInput1, setSavedInput1] = useState('');
  const [savedInput2, setSavedInput2] = useState('');
  const [duration, setDuration] = useState('');
  const [error, setError] = useState('');
  const [gptResponse, setGptResponse] = useState('');
  const accessToken = useState(location.state?.accessToken || null);
  const [genre, setGenre] = useState(''); 
  const [transport, setTransport] = useState('');

  useEffect(() => {
    const loadGoogleMapsScript = async () => {
      const script = document.createElement('script');
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      const response = await fetch(`https://maps.googleapis.com/maps/api/js?key=${apiKey}`);
      script.src = response.url; 
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };
    loadGoogleMapsScript();
  }, []);

  const handleGenreChange = (event) => {
    setGenre(event.target.value);
  };

  const handleTransport = (event) => {
    setTransport(event.target.value);
  };

  const handleInput1Change = (event) => {
    setInput1(event.target.value);
  };

  const handleInput2Change = (event) => {
    setInput2(event.target.value);
  };

  const handleBack = () => {
    navigate('/', );
  };

  const handleSave = async () => {
    setSavedInput1(input1);
    setSavedInput2(input2);
    console.log('Inputs saved:', input1, input2); // Debugging statement
    getDistance(input1, input2, transport, async (durationVal, status) => {
      if (status === 'OK') {
        setDuration(Math.floor(parseFloat(durationVal)));
        setError(''); // Clear any previous error
        console.log('Duration set:', durationVal); // Debugging statement
        if (durationVal > 120) {
          durationVal = 120;
          console.log('Duration capped at 200 minutes for now:', durationVal); // Debugging statement
        }
        try {
          const response = await getGPTResponse(durationVal, genre);
          setGptResponse(response.split('\n').map((item, index) => <li key={index}>{item}</li>));
          const userId = await getSpotifyUserId(accessToken);
          const trackUris = response.split('\n').map(track => {
            if (typeof track === 'string' && track.includes(' - ')) {
              const match = track.match(/(?:\d+\.\s*)?(?:-\s*)?(.*)\s-\s(.*)/);
              if (match) {
                const artistName = match[1].trim();
                const trackName = match[2].trim();
                return { artistName, trackName };
              } else {
                console.error('Invalid track format:', track);
                return null;
              }
            } else {
              console.error('Invalid track format:', track);
              return null;
            }
          }).filter(track => track !== null);
          console.log('Track URIs:', trackUris); // Debugging statement
          if (accessToken) {
            const playlistId = await createPlaylist(userId, accessToken);
            await addTracksToPlaylist(accessToken, playlistId, trackUris);
            alert('Playlist Generated Successfully! Your playlist has been created and tracks have been added.');
          } else {
            console.error('No access token available');
          }
        } catch (error) {
          console.error('Error fetching GPT response:', error);
        }
      } else {
        console.log('Error fetching duration:', status); // Debugging statement
        setError('Could not retrieve directions, please check your input.');
        console.error('Error fetching duration:', status);
      }

    });
  };

  return (
    <div className='app-header'>
          <div className="footer">
        <button onClick={handleBack}>Back</button>
    </div>
    <div className="App">
      <div className="column">
        <h1>Where to today?</h1>
        <div>
          <label>
            Origin: 
             <input type="text" value={input1} onChange={handleInput1Change} />
          </label>
        </div>
        <div>
          <label>
            Destination: 
             <input type="text" value={input2} onChange={handleInput2Change} />
          </label>
        </div>
        <div className="genre">
          <label> Choose Genre:     
          <select value={genre} onChange={handleGenreChange}>
            <option value="Random">Any</option>
            <option value="Rock">Rock</option>
            <option value="Pop">Pop</option>
            <option value="Hip-Hop">Hip-Hop</option>
            <option value="Jazz">Jazz</option>
            <option value="Classical">Classical</option>
            <option value="Electronic">Electronic</option>
          </select>
          </label>
        </div>
        <div className="transport">
        <label> Method of Transportation:     
          <select value={transport} onChange={handleTransport}>
            <option value="DRIVING">Driving</option>
            <option value="WALKING">Walking</option>
            <option value="BICYCLING">Bicycle</option>
            <option value="TRANSIT">Transit</option>
          </select>
          </label>
        </div>
        <button onClick={handleSave}>Generate Playlist</button>
        <p>Saved Origin: {savedInput1}</p>
        <p>Saved Destination: {savedInput2}</p>
        <p>Duration: {duration && `${duration} minutes`}</p>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <h6 style={{ color: 'red', size:10 }}>*Disclaimer: The ChatGPT API may not respond with a valid playlist. In that case, please try pressing Generate again.*</h6>
      </div>
      <div className="column">
        <div className="main-content">
        </div>
        <div className="sidebar">
          <h1>Generated Playlist</h1>
          <ul>{gptResponse}</ul>
        </div>
      </div>
  </div>
  </div>
  );
}

export default App;
